import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var linkAttributesNative = {
  color: 'text.link',
  /**
   * Margin as defined in CSS margin property
   */
  margin: '4px 3px 12px 12px',
  defaultSize: 'l'
};
var linkThemeNative = _objectSpread(_objectSpread({}, linkAttributesNative), {}, {
  variants: {
    condensed: {
      defaultSize: 'm'
    }
  }
});
var linkThemeWeb = {
  color: 'text.link',
  underlineThickness: {
    "default": 'auto',
    hover: '2px'
  }
};

export { linkAttributesNative, linkThemeNative, linkThemeWeb };
